import { Mail, MapPin, Phone } from "lucide-react";
import { resort } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function LocationSection() {
  return (
    <section aria-labelledby="contact-location-heading" className="bg-background py-14 md:py-18">
      <div className="shell">
        <Reveal>
          <Eyebrow>Find Us in Auburn</Eyebrow>
        </Reveal>
        <h2 id="contact-location-heading" className="display-lg mt-6 max-w-[14ch]">
          <MaskReveal>Your Sierra Foothills</MaskReveal>
          <MaskReveal delay={0.08}>Base Camp</MaskReveal>
        </h2>

        <div className="mt-8 grid gap-8 lg:grid-cols-12">
          <div className="order-1 overflow-hidden border border-border lg:col-span-7 lg:order-none">
            <iframe
              title="Map showing the location of Auburn RV Resort at 14400 Musso Road, Auburn, California"
              src={resort.mapsEmbedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="aspect-[4/3] w-full border-0 md:aspect-[16/11] lg:min-h-[420px]"
              allowFullScreen
            />
          </div>

          <Reveal delay={0.08} className="order-2 lg:col-span-5 lg:order-none">
            <div className="border border-border bg-card p-7 md:sticky md:top-28 md:p-9">
              <p className="eyebrow text-muted-foreground">Auburn RV Resort</p>
              <p className="font-display mt-4 text-3xl tracking-tight">Auburn RV Resort</p>
              <address className="mt-4 not-italic text-sm leading-relaxed text-muted-foreground">
                {resort.address.street}
                <br />
                {resort.address.city}, {resort.address.state} {resort.address.zip}
              </address>

              <ul className="mt-6 space-y-3 text-sm">
                <li>
                  <a
                    href={resort.phoneHref}
                    className="inline-flex items-center gap-2 hover:text-primary"
                    aria-label={`Call Auburn RV Resort at ${resort.phone}`}
                  >
                    <Phone className="size-4 text-primary" strokeWidth={1.5} />
                    {resort.phone}
                  </a>
                </li>
                <li>
                  <a
                    href={`mailto:${resort.email}`}
                    className="inline-flex items-center gap-2 break-all hover:text-primary"
                    aria-label={`Email Auburn RV Resort at ${resort.email}`}
                  >
                    <Mail className="size-4 shrink-0 text-primary" strokeWidth={1.5} />
                    {resort.email}
                  </a>
                </li>
                <li className="inline-flex items-start gap-2 text-muted-foreground">
                  <MapPin className="mt-0.5 size-4 shrink-0 text-primary" strokeWidth={1.5} />
                  <span>RV resort Auburn CA · Auburn California RV resort</span>
                </li>
              </ul>

              <div className="mt-8 flex flex-col gap-3">
                <ResortLink
                  variant="solid"
                  href={resort.directionsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full"
                >
                  Get Directions
                </ResortLink>
                <ResortLink variant="outline" href={resort.phoneHref} className="w-full">
                  Call {resort.phone}
                </ResortLink>
                <ResortLink variant="ghost" href={`mailto:${resort.email}`} className="w-full px-0">
                  Email Us
                </ResortLink>
              </div>

              <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
                Use your preferred navigation app for current routing and road conditions.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
